import { Checkbox, Col, Flex, Row, TextField, TextFieldFormats } from '@appliedsystems/applied-design-system';
import React, { ClipboardEvent, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { usePaymentsTranslation } from '../../hooks/usePaymentsTranslation';
import classes from './EftComponentForm.module.scss';

type Props = {
  selectedMethod: string | 'new';
  setDisablePayNowButton: React.Dispatch<React.SetStateAction<boolean>>;
  hideSavePaymentMethod?: boolean;
};

export const EftComponentFormFields = ({
  selectedMethod,
  hideSavePaymentMethod = false,
  setDisablePayNowButton,
}: Props) => {
  const [shouldHideAccountNumber, setShouldHideAccountNumber] = React.useState(false);
  const { resetField, formState } = useFormContext();
  const { t } = usePaymentsTranslation();

  const preventOnPaste = (event: ClipboardEvent<Element>) => {
    event.preventDefault();
  };

  useEffect(() => {
    if (formState.isValid) {
      setDisablePayNowButton(false);
    } else {
      setDisablePayNowButton(true);
    }
  }, [formState.isValid, setDisablePayNowButton]);

  return (
    <>
      {selectedMethod === 'new' && (
        <Flex>
          <Row>
            <Col xs={12}>
              <div style={{ width: '100%' }}>
                <TextField
                  name="accountHolderName"
                  label={t('ACCOUNT_HOLDER_NAME')}
                  placeholder="J. Smith"
                  testId="accountHolderNameTest"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <div style={{ width: '100%' }}>
                <TextField
                  format={TextFieldFormats.DECIMAL_DIGITS}
                  maxLength={3}
                  name="bankNumber"
                  label={t('BANK_NUMBER')}
                  placeholder="3 digits"
                  testId="bankNumberTest"
                />
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <div style={{ width: '100%' }}>
                <TextField
                  format={TextFieldFormats.DECIMAL_DIGITS}
                  maxLength={5}
                  name="transitNumber"
                  label={t('TRANSIT_NUMBER')}
                  placeholder="5 digits"
                  testId="transitNumberTest"
                />
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <div style={{ width: '100%' }}>
                <TextField
                  format={TextFieldFormats.DECIMAL_DIGITS}
                  maxLength={12}
                  name="accountNumber"
                  label={t('ACCOUNT_NUMBER')}
                  placeholder="7-12 digits"
                  testId="accountNumberTest"
                  password={shouldHideAccountNumber}
                  onFocus={() => {
                    resetField('accountNumber');
                    setShouldHideAccountNumber(false);
                  }}
                  onBlur={() => {
                    setShouldHideAccountNumber(true);
                  }}
                />
              </div>
            </Col>
            <Col xs={12} sm={6}>
              <div style={{ width: '100%' }}>
                <TextField
                  maxLength={12}
                  format={TextFieldFormats.DECIMAL_DIGITS}
                  name="reEnterAccountNumber"
                  label={t('RE_ENTER_ACCOUNT_NUMBER')}
                  testId="reEnterAccountNumberTest"
                  onPaste={preventOnPaste}
                />
              </div>
            </Col>
          </Row>
          {hideSavePaymentMethod ? null : (
            <div className={classes.storePaymentMethodCheckbox}>
              <Checkbox type="reverse" name="storePaymentMethod">
                {t('STORE_PAYMENT_METHOD')}
              </Checkbox>
            </div>
          )}
        </Flex>
      )}
    </>
  );
};
